import React from 'react';
import {
  AvailableIcons,
  Button,
  Icon,
  Modal,
  Typography,
  TypographyType,
  TypographyVariant,
} from 'src/components-dummy';
import { ChangesPreview } from 'src/components-bl/FeatureChanges';
import { ChangedEntity } from 'src/components-bl/FeatureChanges/ChangesPreview/types';
import { PreviewTypeEnum } from 'src/app-types/enums/versioning';

export interface FullConfigDiffModalProps {
  isOpen: boolean;
  onClose: () => void;
  changedEntities: ChangedEntity[];
  variantName: string | undefined;
}

// Read-only diff of every change on a variant vs. control, shared by each lever editor's
// "Full config diff" action (Merch Rules, Ranking Strategy, View Config).
export const FullConfigDiffModal = ({
  isOpen,
  onClose,
  changedEntities,
  variantName,
}: FullConfigDiffModalProps): JSX.Element => (
  <Modal className='syte-review-changes-dialog' isOpened={isOpen} onClickOutside={onClose}>
    <>
      <div className='syte-review-changes-dialog-header'>
        <div className='syte-review-changes-dialog-header-title'>
          <Typography
            className='first-row'
            type={TypographyType.Heading}
            variant={TypographyVariant.ExtraSmallBold}
          >
            {`${variantName ?? 'Variant B'} - Review changes`}
          </Typography>
        </div>
        <Icon
          className='syte-review-changes-dialog-header-icon'
          name={AvailableIcons.Close}
          onClick={onClose}
        />
      </div>

      <div className='syte-review-changes-dialog-content'>
        <ChangesPreview
          changedEntities={changedEntities}
          previewType={PreviewTypeEnum.COMPARE_VARIANT}
          newValueCustomName={variantName}
          readOnly
        />
      </div>
      <div className='syte-review-changes-dialog-footer'>
        <Button variant='secondary' className='cancel-button' onClick={onClose}>
          Close
        </Button>
      </div>
    </>
  </Modal>
);
